/// <reference path="../../../../typings/index.d.ts" />
/// <reference path="../../components/baseclasses/guid.ts" />
/// <reference path="../models/meevo.dtos.d.ts" />
/// <reference path="../models/meevo.model.custom.ts" />

module Meevo.Components.Common {
    import SecurityAccessEnum = Meevo.Model.SecurityAccessEnum;

    interface MeevoSecureAttributes extends angular.IAttributes {
        meevoSecureDenyMessage: string;
        overrideDisplayStyle: string;
    }

    export class MeevoSecure implements angular.IDirective {
        restrict = 'A';

        displaySetting: string = '';
        secureClass: string = '';

        private securityKey: string;

        constructor(private securityService: Meevo.Components.Common.ISecurityService,
            private $q: ng.IQService,
            private identityService: Meevo.Components.Common.IIdentityService,
            private $timeout: angular.ITimeoutService,
            private $http: angular.IHttpService) {

        }

        link = (scope: any, element: JQuery, attrs: MeevoSecureAttributes) => {

            const self = this;

            // save original whitelisted display state before hiding
            let display = element.css('display');
            if (['inline', 'inline-block', 'block', 'flex'].indexOf(display.toLowerCase()) !== -1) {
                scope.displaySetting = display;
            }

            //For elements that need their flexing and other classes to be moved to the secure wrapper if it gets applied
            let copyClass = element.attr('secure-copy-classes')
            if (copyClass) {
                scope.copyClasses = true;
                scope.id = element.attr('id');
            }

            this.secureClass = element.attr('secure-class');
            if (Model.Guard.isNothing(this.secureClass)) {
                this.secureClass = "";
            }

            // Hide the element initially, pending retrieval of the permission
            element.hide();

            scope.$on(Meevo.Components.Common.Messages.REFRESH_SECURITY_KEYS, (event) => {
                let val = attrs['meevoSecure']
                scope.observe(val)
            });

            // Get the security key via the attribute value. Using $observe so that the value can be a literal or an interpolated string for binding.
            scope.observe = (value) => {
                this.securityKey = value;
                securityKey = value;
                if (Model.Guard.isNothing(securityKey)) {
                    element.show();
                    return;
                }
                if (typeof securityKey.startsWith != 'function') {
                    Object.defineProperty(String.prototype, 'startsWith', {
                        value: function (search, pos) {
                            return this.substring(!pos || pos < 0 ? 0 : +pos, search.length) === search;
                        }
                    });
                }
                if (!securityKey.toUpperCase().startsWith('CUSTOM_ENTITY_')) {

                    //check if its a FIELD
                    if (securityKey.toUpperCase().indexOf(Meevo.Components.Common.SecurityParts.KEY_PART_FIELD + ':') >=
                        0 &&
                        securityKey.toUpperCase().indexOf(Meevo.Components.Common.SecurityParts.KEY_PART_READ + ':') <=
                        0) {
                        //TODO: Remove :READ and :WRITE from data, then only use one key
                        //We are using the READ for the fields now
                        securityKey = securityKey + Meevo.Components.Common.SecurityParts.KEY_PART_READ;
                    }

                    if (self.CheckIfKeyHasAVerb(securityKey) === false)
                        securityKey = securityKey + Meevo.Components.Common.SecurityParts.KEY_PART_READ;
                } else {

                    securityKey = securityKey.toLowerCase();
                }
                //Lookup key
                self.securityService.checkSecurityItem(securityKey)
                    .then((result: Model.SecurityItem) => {
                        self.modifyElement(scope, element, result, securityKey, attrs.meevoSecureDenyMessage, attrs.overrideDisplayStyle);
                    })
                    .catch((result: Model.SecurityItem) => {
                        console.debug(`Secure Directive Warning : ${result.key} Not Found`);
                        self.securityFailure(element, result);
                    });
            }

            let securityKey = null;

            attrs.$observe('meevoSecure', scope.observe);

        };

        private CheckIfKeyHasAVerb(securityKey: string): boolean {
            const partsToCheck = [
                Meevo.Components.Common.SecurityParts.KEY_PART_FILTER,
                Meevo.Components.Common.SecurityParts.KEY_PART_ACTION,
                Meevo.Components.Common.SecurityParts.KEY_PART_DELETE,
                Meevo.Components.Common.SecurityParts.KEY_PART_WRITE,
                Meevo.Components.Common.SecurityParts.KEY_PART_READ,
                Meevo.Components.Common.SecurityParts.KEY_PART_UNDELETE,
                Meevo.Components.Common.SecurityParts.KEY_PART_COPY,
                Meevo.Components.Common.SecurityParts.KEY_PART_CREATE,
                Meevo.Components.Common.SecurityParts.KEY_PART_CHANGEACCESS,
                Meevo.Components.Common.SecurityParts.KEY_PART_CHANGEOWNER,
                Meevo.Components.Common.SecurityParts.KEY_PART_AVAILABLETOLOCATIONS,
                Meevo.Components.Common.SecurityParts.KEY_PART_EDIT,
                Meevo.Components.Common.SecurityParts.KEY_PART_COMMIT,
                Meevo.Components.Common.SecurityParts.KEY_PART_PURGE
            ];
            var foundPart: boolean = false;
            _.forEach(partsToCheck,
                part => {
                    if (securityKey.toUpperCase().indexOf(part) >= 0) {
                        foundPart = true;
                    }
                });
            return foundPart;

        }

        private securityFailure(element: JQuery, securityKey: Model.SecurityItem): void {
            element.removeAttr('meevo-btn-sc');
            element.removeAttr('ng-click');
            element.attr('meevo-secure', securityKey.key + ':NOTFOUND');
            element.prop('disabled', true);
            /*
             * TODO: Remove ShortCut Event For Hidden elements
             * We Cannot Remove element, .show() Will Not Work If .remove() Was Applied
             */
            element.hide();
            return;
        }

        private elementClick(element) {
            var me = this;
            this.$timeout(function () {
                angular.element(element).triggerHandler('click');
            }, 0);

        }
        private raiseElevationMessage(event, scope, q, securityKey, element, displayName: string, securityKeyPath: string): void {
            var defer;
            defer = q.defer();

            defer.promise.then(() => {
                this.elementClick(element);

                if (!element.is("button")) {
                    $(element).parent().find(".secure-disabled-blocker").first().remove();
                    element.removeAttr('readonly');
                    element.removeAttr('disabled');
                    element.children().find("*").removeAttr('tabindex');
                    element.children().find("*").removeAttr('readonly');
                    element.children().find("*").removeAttr('disabled');
                    element.unwrap();
                }

            });

            scope.$emit(Meevo.Components.Common.Messages.ELEVATION_CHALLENGE, defer, securityKey.replace(/:/gi, '_'), displayName, this.identityService.current().userName, securityKeyPath);
        }
        private modifyElement(scope, element: JQuery, securityItem: Model.SecurityItem, securityKey: Model.SecurityItem, denyMessage: string, overrideDisplayStyle: string = ''): void {

            if (Model.Guard.isNothing(securityItem)) {
                this.securityFailure(element, securityKey);
                return;
            }

            const promptOnHide = element.attr('meevo-secure-prompt-on-hide') === 'true';
            const denyWhenHide = element.attr('meevo-secure-deny-when-hide') === 'true';

            if (securityItem.securityAccess == SecurityAccessEnum.Hide && !promptOnHide && !denyWhenHide) {
                element.hide();
                return;
            }

            element.show();

            if (securityItem.securityAccess == SecurityAccessEnum.Grant) {
                if (element.parent('.secure-wraper').length) {
                    element.removeAttr('tabindex');
                    element.removeAttr('readonly');
                    element.removeAttr('disabled');
                    element.children().find("*").removeAttr('tabindex');
                    element.children().find("*").removeAttr('readonly');
                    element.children().find("*").removeAttr('disabled');
                    $(element).parent().find(".secure-disabled-blocker").first().remove();
                    element.unwrap();
                }
                return;
            }

            /*Note:Doesnt work will be overwritten by an ng-disabled on element when watcher chagnes it
              element.find('input, select, textarea,button').attr('disabled', 'disabled'); */

            /* for elements */
            element.attr('tabindex', '-1');
            element.attr('readonly', 'readonly');
            element.attr('disabled', 'disabled');
            /* for all the Child elements */
            element.children().find("*").attr('tabindex', '-1');
            element.children().find("*").attr('readonly', 'readonly');
            element.children().find("*").attr('disabled', 'disabled');

            if (element.parent('.secure-wraper').length) {
                $(element).parent().find(".secure-disabled-blocker").first().remove();
                element.unwrap();
            }

            let elementClasses: string = "";
            //Move classes from the element to the wrapper if specified
            if (scope.copyClasses) {
                elementClasses = element.attr('class');
                element.removeClass();
            }
            let wrapperHtml: string;
            // Need to promote display prop to the wrapper so that it doesn't screw up positioning in the case where display is inline-block
            if (overrideDisplayStyle == 'true') {
                wrapperHtml = `<div class='secure-wraper ${this.secureClass} ${elementClasses}' style='position: relative; display:`
                    + (scope.displaySetting ? scope.displaySetting : 'block')
                    + `;'`
                    + (scope.id ? `id = '${scope.id}'` : '')
                    + `> </div>`;
            }
            else {
                wrapperHtml = `<div class='secure-wraper ${this.secureClass} ${elementClasses}' style='position: relative;'`
                    + (scope.id ? `id = '${scope.id}'` : '')
                    + `> </div>`;
            }
            element.wrap(wrapperHtml);
            if (scope.displaySetting && scope.displaySetting.length > 0) {
                element.css('display', scope.displaySetting);
            }

            if (securityItem.canElevate && !(securityItem.securityAccess === SecurityAccessEnum.Hide && promptOnHide)) {
                var classname = "forElevation" + (Math.random() * 9) + 1;
                classname = classname.replace('.', '');

                element.before("<div class='secure-disabled-blocker " + classname + "' ></div>");
                var fullclassname = "." + classname;

                $(fullclassname).on("click", (event) => {
                    event.stopPropagation();

                    this.$http.post('/api/Alert/Trigger/AccessDenied', { securityKey });
                    this.raiseElevationMessage(event, scope, this.$q, securityKey, element, securityItem.displayName, securityItem.securityKeyPath);
                });

            } else {
                $(element).parent().find(".secure-disabled-blocker").first().remove();
                element.before("<div class='secure-disabled-blocker' ></div>");
                if (denyMessage) {
                    element.siblings(".secure-disabled-blocker").on("click", () => {
                        this.securityService.showDenyWarning(securityItem.securityKeyPath, this.securityKey, denyMessage);
                    });
                }
                if (!securityItem.canElevate && Model.Guard.isNothing(denyMessage)) {
                    element.siblings(".secure-disabled-blocker").on("click",
                        () => {
                            this.securityService.showDenyWarning(securityItem.securityKeyPath, this.securityKey);
                        });
                }

            }

            return;
        }


        static factory(): angular.IDirectiveFactory {
            const directive = (securityService: Meevo.Components.Common.ISecurityService,
                $q: ng.IQService,
                identityService: Meevo.Components.Common.IIdentityService,
                $timeout: angular.ITimeoutService,
                $http: angular.IHttpService) => {
                return new MeevoSecure(securityService, $q, identityService, $timeout, $http);
            };
            directive.$inject = [
                'meevo.components.common.SecurityService', '$q', 'meevo.components.common.IdentityService', '$timeout', '$http',
            ];
            return directive;
        }
    }

    angular.module('meevo')
        .directive('meevoSecure', MeevoSecure.factory());
}
